import { verisModule } from "clients/verisModule";
import { useCustomWallet } from "components/providers";
import { useMemo } from "react";

export const useUAccountEtherscanHref = () => {
  const { smartAddress } = useCustomWallet();

  return useMemo<string>(
    () =>
      !smartAddress
        ? "#"
        : `https://${
            verisModule.chainName === "mainnet"
              ? ""
              : verisModule.chainName + "."
          }etherscan.io/address/${smartAddress}`,
    [smartAddress]
  );
};
